import PropTypes from 'prop-types';
import { Field } from 'formik';
import map from 'lodash/map';
import includes from 'lodash/includes';
import reject from 'lodash/reject';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  field: {
    margin: theme.spacing(1, 0),
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  checkbox: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const CheckboxGroupField = ({ name, label, options, disabled, touched, helperText, className }) => {
  const classes = useStyles();

  return (
    <Field name={name}>
      {({ field, form }) => (
        <FormControl
          component="fieldset"
          error={(touched || form.touched[field.name]) && Boolean(form.errors[field.name])}
          className={clsx(classes.field, className)}
        >
          {label && <FormLabel component="legend" className={classes.label}>{label}</FormLabel>}
          <FormGroup>
            {map(options, (option) => {
              return (
                <FormControlLabel
                  key={option.value}
                  control={(
                    <Checkbox
                      id={name}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        let newValue;
                        if (checked) {
                          newValue = field.value.concat(option.value);
                        } else {
                          newValue = reject(field.value, (v) => v === option.value);
                        }
                        form.setFieldValue(field.name, newValue);
                      }}
                      value={option.value}
                      checked={includes(field.value, option.value)}
                      classes={{ root: classes.checkbox }}
                    />
                  )}
                  label={option.label}
                  disabled={disabled}
                />
              )
            })}
          </FormGroup>
          {(((touched || form.touched[field.name]) && form.errors[field.name]) || helperText) && (
            <FormHelperText className={classes.helperText}>
              {((touched || form.touched[field.name]) && form.errors[field.name]) || helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    </Field>
  );
};

CheckboxGroupField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  helperText: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.node,
    className: PropTypes.string
  })),
  className: PropTypes.string
};

export default CheckboxGroupField;
